//引数
interface IFProps {
    isShow: boolean,
    setIsShow: React.Dispatch<React.SetStateAction<boolean>>,
    callback:any
    msg:string
}

export function Dialog(props:IFProps): JSX.Element{

    let showClass = "";

    //表示時処理
    if (props.isShow){
        showClass = "is-show";
    }

    //処理を呼び出す
    function clickSubmit(){
        props.callback()
    }

    //モーダルを閉じる
    function clickClose(){
        props.setIsShow(false);
    }

    return(
        <div className={"modal " + showClass}>
            <div className="modal-back" onClick={clickClose}></div>
            <div className="modal-box">
                {props.msg}
                <div className="modal-button">
                    <button className="btn-primary" onClick={clickSubmit}>OK</button>
                    <button className="btn-secondary" onClick={clickClose}>キャンセル</button>
                </div>
            </div>
        </div>
    )

}